import React from 'react';

export function Timapantanir() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="112"
      height="112"
      viewBox="0 0 112 112"
    >
      <g
        id="Ársskýrsla/icon/Tímapantanir"
        fill="none"
        fillRule="evenodd"
        stroke="#163E63"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      >
        <g id="calendar-check-1" transform="translate(20 15)">
          <circle id="Oval" cx="60.979" cy="60.983" r="21.25"></circle>
          <path
            id="Path"
            d="M70.45 54.803L60.16 68.523a2.66 2.66 0 01-4.006.283l-5.312-5.312"
          ></path>
          <path id="Path" d="M18.479 0.774L18.479 18.483"></path>
          <path id="Path" d="M53.896 0.774L53.896 18.483"></path>
          <path id="Path" d="M0.771 25.566L71.604 25.566"></path>
        </g>
        <path
          id="Path"
          d="M52.646 79.52H24.312a3.542 3.542 0 01-3.541-3.54V26.395a3.542 3.542 0 013.541-3.542h63.75a3.542 3.542 0 013.542 3.542v23.02"
        ></path>
      </g>
    </svg>
  );
}
